import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { setApiMessage } from "./globalApiMessageSlice";
import { setLoading } from "./loading";
// import axios from "axios";
import axios from "../../GlobalAPIErrorHandler/axiosConfig";
import _ from "lodash";

export const loadNotificationThunk = createAsyncThunk(
  "alert/loadAlerts",
  async (arg, { getState, rejectWithValue, dispatch }) => {
    try {
      const { login } = getState();
      if(arg !== 'isLandingPage'){
      dispatch(setLoading(true));
      }
      const API_HOST_SEARCH = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_ADMIN}`;
      if (login.token) {
        const iac = login?.userInfoAttr?.userInfo?.userAttributes?.iac;
        const endpoints = [
          `${API_HOST_SEARCH}/alert/loadAnnouncement`,
          `${API_HOST_SEARCH}/alert/loadPlacedOrder`,
          `${API_HOST_SEARCH}/alert/loadShippedItem`,
          `${API_HOST_SEARCH}/alert/loadExpiredItem?iacCode=${iac}&companyNumber=${login.decodedTokenObject.compNumber}`,
        ];
        await axios.all(
          endpoints.map((endpoint) =>
            axios.post(endpoint, null, {
              headers: {
                jwtToken: login.token,
              },
            })
          )
        );
        dispatch(setApiMessage());
        return true;
      }
    } catch (error) {
      dispatch(setApiMessage(error.response.data));
      return rejectWithValue(error);
    } finally {

      if(arg === 'isLandingPage'){
        dispatch(
          getUnreadAlertThunk()
        );
      } else {
        dispatch(
          getNotificationThunk({
            initial: true,
          })
        );
        dispatch(setLoading(false));
      }
    }
  }
);

export const getNotificationThunk = createAsyncThunk(
  "alert/getAllAlerts",
  async (arg, { getState, rejectWithValue, dispatch }) => {
    try {
      const { login } = getState();
      dispatch(setLoading(true));
      const API_HOST_SEARCH = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_ADMIN}`;
      if (login.token) {
        const stateData = getState().notification;
        const payloadd = {
          companyDivisionId: login?.decodedTokenObject?.compDivId,
          appUserId: login?.decodedTokenObject?.AppUserId,
          page: arg.initial ? 1 : stateData.notifications.page + 1,
          pageSize: 30,
        };
        const { data } = await axios.post(
          `${API_HOST_SEARCH}/alert/getAlert`,
          payloadd,
          {
            headers: {
              jwtToken: login.token,
            },
          }
        );
        dispatch(setApiMessage());
        return { data, stateData, initial: arg.initial };
      }
    } catch (error) {
      dispatch(setApiMessage(error.response.data));
      return rejectWithValue(error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);

// get unread alert header
export const getUnreadAlertThunk = createAsyncThunk(
  "alert/getUnreadAlert",
  async (arg, { getState, rejectWithValue, dispatch }) => {
    try {
      const { login } = getState();
      const API_HOST_SEARCH = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_ADMIN}`;
      if (login.token) {
        // const stateData = getState().notification;
        const payloadd = {
          companyDivisionId: login?.decodedTokenObject?.compDivId,
          appUserId: login?.decodedTokenObject?.AppUserId,
        };
        const { data } = await axios.post(
          `${API_HOST_SEARCH}/alert/getUnReadAlertsCount`,
          payloadd,
          {
            headers: {
              jwtToken: login.token,
            },
          }
        );
        dispatch(setApiMessage());
        return data;
      }
    } catch (error) {
      dispatch(setApiMessage(error.response.data));
      return rejectWithValue(error);
    }
  }
);

// read notification saga
export const readNotificationThunk = createAsyncThunk(
  "notification/read",
  async ({ isReadAll, id }, { getState, rejectWithValue, dispatch }) => {
    try {
      const { login } = getState();
      const API_HOST_SEARCH = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_ADMIN}`;
      if (login.token) {
        const payloadd = {
          companyDivisionId: login?.decodedTokenObject?.compDivId,
          appUserId: login?.decodedTokenObject?.AppUserId,
          alertId: id,
        };
        const url = isReadAll ? "markReadAll" : "markRead";
        const { data } = await axios.post(
          `${API_HOST_SEARCH}/alert/${url}`,
          payloadd,
          {
            headers: {
              jwtToken: login.token,
            },
          }
        );
        return data;
      }
    } catch (error) {
      dispatch(setApiMessage(error.response.data));
      return rejectWithValue(error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);

// mark Read Announcement
export const markReadAnnouncement = createAsyncThunk(
  "notification/read",
  async (arg, { getState, rejectWithValue, dispatch }) => {
    try {
      const { login } = getState();
      const API_HOST_SEARCH = `${process.env.REACT_APP_API_HOST_URL}${process.env.REACT_APP_ADMIN}`;
      if (login.token) {
        dispatch(setLoading(true));
        const payloadd = {
          companyDivisionId: login?.decodedTokenObject?.compDivId,
          appUserId: login?.decodedTokenObject?.AppUserId,
          alertId: arg,
        };
        const { data } = await axios.post(
          `${API_HOST_SEARCH}/alert/markReadAnnouncement`,
          payloadd,
          {
            headers: {
              jwtToken: login.token,
            },
          }
        );

        dispatch(setLoading(true));
        return data;
      }
    } catch (error) {
      dispatch(setApiMessage(error.response.data));
      return rejectWithValue(error);
    } finally {
      dispatch(setLoading(false));
    }
  }
);

const notificationSlice = createSlice({
  name: "notifications",
  initialState: {
    notifications: { alertList: [], page: 0, WEEK: [], MONTH: [], OLDER: [] },
    readAll: false,
    loading: false,
    isSuccess: false,
    unreadCount: 0,
  },

  reducers: {
    setSelectedCategoryTagId(state, action) {
      const { payload } = action;
      state.tagData = payload;
    },
  },
  extraReducers: {
    [loadNotificationThunk.pending]: (state, { payload }) => {
      state.notifications = {
        alertList: [],
        page: 0,
        WEEK: [],
        MONTH: [],
        OLDER: [],
      };
    },
    [getNotificationThunk.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [getNotificationThunk.fulfilled]: (state, { payload }) => {
      const allAlerts = _.compact([
        ...(payload.initial ? [] : payload.stateData.notifications.alertList),
        ...payload?.data?.alertList,
      ]);
      const groupAlerts = _.groupBy(allAlerts, "duration");
      state.notifications = {
        ...payload.data,
        alertList: allAlerts,
        ...groupAlerts,
      };
    },
    [getNotificationThunk.rejected]: (state, payload) => {
      state.loading = false;
    },
    [getUnreadAlertThunk.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.unreadCount = payload;
    },
    [getUnreadAlertThunk.rejected]: (state, payload) => {
      state.loading = false;
      state.unreadCount = 0;
    },

    [readNotificationThunk.pending]: (state, { payload }) => {
      state.loading = false;
      state.readAll = true;
    },
    [readNotificationThunk.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.readAll = true;
    },
    [readNotificationThunk.rejected]: (state, payload) => {
      state.loading = false;
      state.readAll = true;
    },
    [markReadAnnouncement.pending]: (state, { payload }) => {
      state.loading = false;
    },
    [markReadAnnouncement.fulfilled]: (state, { payload }) => {
      state.loading = false;
    },
    [markReadAnnouncement.rejected]: (state, payload) => {
      state.loading = false;
    },
  },
});
export const { setSelectedCategoryTagId } = notificationSlice.actions;
export default notificationSlice.reducer;
